import { createAction, props } from '@ngrx/store';
import { Workspace } from '../workspaces.models';

export const openWorkspacesModal = createAction('[Workspaces] Open modal');
export const closeWorkspacesModal = createAction('[Workspaces] Close modal');

export const getWorkspacesList = createAction(
  '[Workspaces] Get workspaces list',
  props<{ params: any; isWorkspacesView?: boolean }>(),
);
export const getWorkspacesListResponse = createAction(
  '[Workspaces] Get workspaces list response',
  props<{ workspaces: Workspace[] }>(),
);
export const getWorkspacesListError = createAction('[Workspaces] Get workspaces list error', props<{ err: any }>());

export const searchWorkspacesList = createAction('[Workspaces] Search workspaces list', props<{ params: any }>());
export const searchWorkspacesListResponse = createAction(
  '[Workspaces] Search workspaces list response',
  props<{ workspaces: Workspace[] }>(),
);

export const loadMoreWorkspacesList = createAction('[Workspaces] Load more workspaces list', props<{ params: any }>());
export const loadMoreWorkspacesListResponse = createAction(
  '[Workspaces] Load more workspaces list response',
  props<{ workspaces: Workspace[] }>(),
);

export const saveWorkspace = createAction('[Workspaces] Save workspace', props<{ workspace: Partial<Workspace> }>());
export const saveWorkspaceResponse = createAction('[Workspaces] Save workspace response', props<{ data: Workspace }>());
export const saveWorkspaceError = createAction('[Workspaces] Save workspace error', props<{ error: any }>());

export const updateWorkspace = createAction(
  '[Workspaces] Update workspace',
  props<{ workspace: Partial<Workspace>; params: any; workspaceId: number }>(),
);
export const updateWorkspaceResponse = createAction(
  '[Workspaces] Update workspace response',
  props<{ data: Workspace }>(),
);
export const updateWorkspaceError = createAction('[Workspaces] Update workspace error', props<{ error: any }>());

export const removeWorkspace = createAction('[Workspaces] Remove workspace', props<{ workspaceId: number }>());
export const removeWorkspaceItem = createAction('[Workspaces] Remove workspace item', props<{ data: Workspace }>());
export const removeWorkspaceResponse = createAction(
  '[Workspaces] Remove workspace response',
  props<{ data: Workspace }>(),
);
export const removeWorkspaceError = createAction('[Workspaces] Remove workspace error', props<{ error: any }>());
